import { OrderItem, PaymentSummary } from "Views/Components/PaymentSummaryCard/PaymentSummaryCard";

export const gstRate = 0.1;

const diffToOrginialPrice = (originalPrice: number, price: number) => {
	const originalPriceRounded = Math.floor(originalPrice * 100) / 100;
	const priceRounded = Math.floor(price * 100) / 100;
	return originalPriceRounded !== priceRounded;
}

type OrderItemWithDiscount = OrderItem & { isDiscounted: boolean };

export const PaymentSummaryUtil = {
	getGstAmount(paymentSummary: PaymentSummary): number {
		const subTotal = this.getSubTotal(paymentSummary);
		return subTotal * gstRate;
	},
	getAvailableItems(paymentSummary: PaymentSummary): OrderItemWithDiscount[] {
		return paymentSummary.orderItems.map(item => ({
			id: item.id,
			name: item.name,
			price: item.price,
			originalPrice: item.originalPrice,
			isDiscounted: diffToOrginialPrice(item.originalPrice, item.price),
		}));
	},
	getSubTotal(paymentSummary: PaymentSummary): number {
		return paymentSummary.orderItems.reduce((acc, item) => acc + item.price, 0);
	},
	getTotalIncludingGst(paymentSummary: PaymentSummary): number {
		const subTotal = this.getSubTotal(paymentSummary);
		return subTotal * (1 + gstRate);
	},
	getOriginalSubTotal(paymentSummary: PaymentSummary): number {
		return paymentSummary.orderItems.reduce((acc, item) => acc + item.originalPrice, 0);
	}
};